import LanguageTestRender from '../../../components/pages/language-test/client-space/language-test-render'
import useEnrollment from '../../../lib/hooks/use-enrollment'
import LanguageTestProvider from './context/language-test-context'

const ClientInformationsTestPage = () => {
  const { enrollment } = useEnrollment()

  return (
    <LanguageTestProvider enrollmentId={enrollment.id}>
      <LanguageTestRender />
    </LanguageTestProvider>
  )
}

export default ClientInformationsTestPage
